import React from 'react';
import { useTour } from '../../contexts/TourContext';
import './TourProgress.css';

const TourProgress: React.FC = () => {
  const { state } = useTour();
  const { currentStep } = state;
  const totalSteps = 6;

  const progressPercentage = (currentStep / totalSteps) * 100;

  return (
    <div className="tour-progress">
      <div className="tour-progress-bar">
        <div 
          className="tour-progress-fill" 
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <div className="tour-progress-text">
        Schritt {currentStep} von {totalSteps}
      </div>
    </div>
  );
};

export default TourProgress;
